"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.notify.done': 'Thanks for creating me. Tell me how I can help you.',
};
